import KeyDealFeatures from './key-deal-features';
export default KeyDealFeatures;